export default "__VITE_ASSET__b1a89489__"